import { useSelector } from "react-redux";
import styled from "styled-components";
import Robot from "../assets/robot.gif";
const Welcome = ({ setDisplayContacts }) => {
  const { user } = useSelector((state) => state.user);
  return (
    <Wrapper>
      <img src={Robot} alt="" />
      <h1>
        Welcome, <span>{user?.Username}!</span>
      </h1>
      <h3>Please select a chat to Start messaging.</h3>
      <button className="button" onClick={() => setDisplayContacts(true)}>Open Contacts</button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  flex-direction: column;
  .button{
    display:none ;
  }
  img {
    height: 20rem;
  }
  span {
    color: #4e0eff;
  }
  @media (max-width:720px){
    h3{
      font-size:1rem ;
    }
    .button{
      display:block;
      margin-top:1rem;
      background-color:#9a86f3 ;
      color:#fefefe ;
      cursor: pointer;
      border:none ;
      border-radius: 10px;
      padding:1rem ;
    }
  }
`;

export default Welcome;